/**
 * Report form (meeting synthesis).
 */
import * as React from 'react';
import { FileText } from 'lucide-react';
import { Rating } from '@/components/forms/Rating';
import { Textarea } from '@/components/forms/Textarea';
import { setReportField } from '@/components/reports/remote/report-form-utils';

/** Props for {@link MeetingSynthesisForm}. */
export interface MeetingSynthesisFormProps {
  fields: Record<string, unknown>;
  onChange: (patch: Record<string, unknown>) => void;
  isReadOnly: boolean;
  meetingLabel: string;
}

/** Synthesis fields for a remote information/welcome meeting report. */
export const MeetingSynthesisForm: React.FC<Readonly<MeetingSynthesisFormProps>> = ({
  fields,
  onChange,
  isReadOnly,
  meetingLabel,
}) => {
  const set = (key: string, value: unknown) => setReportField(onChange, key, value);

  return (
    <div className="form-section">
      <h4 className="form-section-title">
        <FileText className="w-4 h-4" />
        Synthèse — Réunion {meetingLabel}
      </h4>
      <div className="space-y-4">
        <Textarea
          label="Synthèse libre"
          required
          placeholder="Décrivez le déroulement et les points abordés…"
          value={(fields.syntheseLibre as string) ?? ''}
          onChange={(e) => set('syntheseLibre', e.target.value)}
          rows={4}
          autoResize
          maxLength={3000}
          showCharCount
          disabled={isReadOnly}
        />
        <Rating
          label="Niveau d'engagement des participants"
          required
          value={(fields.niveauEngagement as number) ?? null}
          onChange={(v) => set('niveauEngagement', v)}
          helperText="Évaluez l'engagement général /5"
          readOnly={isReadOnly}
        />
      </div>
    </div>
  );
};
